import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Start Main 
import Header from "../main/Header";
import Footer from '../main/Footer';

// Start Pages
import Home from "../pages/Home";
import Offers from '../pages/Offers';
import Setting from '../pages/Setting';
import Menu from '../pages/Menu';
import Cart from '../pages/Cart';
import BestSeller from "../pages/BestSeller";
import MenuList from '../pages/MenuList';
import ItemsDetails from '../pages/ItemsDetails';
import Checkout from '../pages/Checkout';


function MainLayout() {

  return (
    <section className="flex flex-col">
      <section className={`flex flex-col w-[100%]`}>
        <Header />
        <section className="w-full h-full pb-[100px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/bestSeller" element={<BestSeller />} />
            <Route path='/items-details/:id' element={<ItemsDetails />} />
            <Route path='/menu-list/:categoryId' element={<MenuList />} />
          </Routes>
        </section>
        <Footer />
      </section>
      <ToastContainer />
    </section>
  );
}

export default MainLayout;
